export default __webpack_public_path__ + "static/media/Commercial_Software_License_Agreement_rev_3_3_21.d0dc7cbe.pdf";